import React from "react";
import tokenService from '../../../utils/tokenDecoder';
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table,
    Paper,
    Divider
} from '@material-ui/core';
import CountUp from 'react-countup';

export default class ComponentToPrint extends React.Component {
    render() {
        const gridDatArray = this.props.gridDatArray;
        const requisitionDetails = this.props.requisitionDetails;
        const searchData = this.props.selectedSearchValues;
        const requisitionNumber = this.props.requisitionNumber;
        const estateName = this.props.estateName;
        const enteredByUser = this.props.enteredByUser;
        const checkedByUser = this.props.checkedByUser;
        const totalRequestedQuantity = gridDatArray.reduce((accumulator, current) => accumulator + current.requestedQuantity, 0);
        
        const logoUrl = "/static/images/agarapathana-logo.png"; 

        return (
            <div style={{ padding: '20px', maxWidth: '100%', fontFamily: 'Arial, sans-serif' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                <div style={{ marginRight: '15px' }}>
                    {/* <img 
                        src={logoUrl} 
                        alt="APL Logo" 
                        style={{ width: '50px', height: '50px' }} 
                    /> */}
                    </div>
                    <h1 style={{ margin: 0, fontWeight: 'bold', fontSize: '32px' }}>Gurugodella Tea Factory</h1>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <div>
                        <span style={{ fontWeight: 'bold' }}>Factory Name: </span>
                        <span>{estateName}</span>
                    </div>
                    <div>
                        <span style={{ fontWeight: 'bold' }}>Date: </span>
                        <span>{requisitionDetails.requestDate ? (requisitionDetails.requestDate).toString().split('T')[0] : ''}</span>
                    </div>
                </div>
                
                <Divider style={{ height: '1px', backgroundColor: 'black', margin: '10px 0 15px 0' }} />

                <div style={{ marginBottom: '15px' }}>
                    <span style={{ fontWeight: 'bold' }}>Requisition No: </span>
                    <span>{requisitionNumber}</span>
                </div>

                <Divider style={{ height: '1px', backgroundColor: 'black', margin: '10px 0 15px 0' }} />

                <Box minWidth={650}>
                    <TableContainer component={Paper} style={{ boxShadow: 'none', border: '1px solid black' }}>
                        <Table size="small" aria-label="requisition table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ border: "1px solid black", width: "10%", fontWeight: 'bold', textAlign: 'center' }}>
                                        S/No
                                    </TableCell>
                                    <TableCell style={{ border: "1px solid black", width: "60%", fontWeight: 'bold', textAlign: 'center' }} colSpan={2}>
                                        Description of Item
                                    </TableCell>
                                    <TableCell style={{ border: "1px solid black", width: "30%", fontWeight: 'bold', textAlign: 'center' }} colSpan={3}>
                                        Quantity
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ border: "1px solid black", width: "10%", fontWeight: 'bold', textAlign: 'center' }}>
                                        
                                    </TableCell>
                                    <TableCell style={{ border: "1px solid black", width: "20%", fontWeight: 'bold', textAlign: 'center' }}>
                                        SKU Code
                                    </TableCell>
                                    <TableCell style={{ border: "1px solid black", width: "40%", fontWeight: 'bold', textAlign: 'center' }}>
                                        SKU Name
                                    </TableCell>
                                    <TableCell style={{ border: "1px solid black", width: "10%", fontWeight: 'bold', textAlign: 'center' }}>
                                        QTY
                                    </TableCell>
                                    <TableCell style={{ border: "1px solid black", width: "10%", fontWeight: 'bold', textAlign: 'center' }}>
                                        Unit
                                    </TableCell>
                                    <TableCell style={{ border: "1px solid black", width: "10%", fontWeight: 'bold', textAlign: 'center' }}>
                                        
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {gridDatArray.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell style={{ border: "1px solid black", textAlign: 'center' }}>
                                            {index + 1}
                                        </TableCell>
                                        <TableCell style={{ border: "1px solid black", textAlign: 'center' }}>
                                            {row.skuMasterCode}
                                        </TableCell>
                                        <TableCell style={{ border: "1px solid black" }}>
                                            {row.skuMasterName}
                                        </TableCell>
                                        <TableCell style={{ border: "1px solid black", textAlign: 'right' }}>
                                            {row.requestedQuantity ? (row.requestedQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                        </TableCell>
                                        <TableCell style={{ border: "1px solid black", textAlign: 'center' }}>
                                            {row.skuMesuringUnit}
                                        </TableCell>
                                        <TableCell style={{ border: "1px solid black", textAlign: 'center' }}>
                                            {" "}
                                        </TableCell>
                                    </TableRow>
                                ))}
                                <TableRow>
                                    <TableCell colSpan={2} style={{ border: "1px solid black" }}>
                                        
                                    </TableCell>
                                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", textAlign: 'left' }}>
                                        Total
                                    </TableCell>
                                    <TableCell style={{ border: "1px solid black", textAlign: 'right', fontWeight: 'bold' }}>
                                        <CountUp decimals={2} separator=',' end={totalRequestedQuantity} duration={1} />
                                    </TableCell>
                                    <TableCell style={{ border: "1px solid black" }} colSpan={2}>
                                        
                                    </TableCell>
                                </TableRow>
                               
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                
                <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                        <div style={{ marginBottom: '5px' }}>
                            <span style={{ fontWeight: 'bold' }}>Entered By: </span>
                            <span>{enteredByUser || ''}</span>
                        </div>
                        <div>
                            <span style={{ fontWeight: 'bold' }}>Checked By: </span>
                            <span>{checkedByUser || ''}</span>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop:'20px' }}>
                        <div style={{ borderBottom: '1px dotted black', width: '200px', textAlign: 'center', paddingBottom: '5px' }}></div>
                        <div style={{ textAlign: 'center', marginTop: '5px' }}>Manager</div>
                    </div>
                </div>
            </div>
        );
    }
}